import { Link } from 'react-router-dom';
import { mangaCategories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">
                番木瓜漫画
              </span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed">
              番木瓜漫画免费全集阅读专区，提供海量热门漫画的免费全集，支持下拉式阅读，在线免费看全集，漫画大全尽在番木瓜漫画。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              漫画分类
            </h4>
            <ul className="space-y-2">
              {mangaCategories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/rexue"
                  className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  全部分类
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  帮助中心
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              关注我们
            </h4>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                aria-label="微博"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                aria-label="微信"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                aria-label="B站"
              >
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
            <p className="mt-4 text-xs text-secondary-400">
              联系邮箱：contact@fanmugua.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 番木瓜漫画 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">
              服务条款
            </a>
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">
              DMCA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}